import { render, staticRenderFns } from "./FluxoCaixaCategoriasProfile.vue?vue&type=template&id=5b847e75"
import script from "./FluxoCaixaCategoriasProfile.vue?vue&type=script&lang=js"
export * from "./FluxoCaixaCategoriasProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports